import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  EllipsisOutlined,
  MinusCircleOutlined,
  PauseOutlined,
  PlayCircleOutlined,
  SyncOutlined,
} from '@ant-design/icons'
import { algorithmRunStatuses } from '../../constants/constants'
import { AlgorithmRunStatus } from '../../types/generalTypes'

const statusToComponentMap = {
  [algorithmRunStatuses.ONGOING]: SyncOutlined,
  [algorithmRunStatuses.ONGOING_AI]: SyncOutlined,
  [algorithmRunStatuses.ONGOING_INGESTION]: SyncOutlined,
  [algorithmRunStatuses.COMPLETE]: CheckCircleOutlined,
  [algorithmRunStatuses.FAILED]: CloseCircleOutlined,
  [algorithmRunStatuses.CANCELLED]: MinusCircleOutlined,
  [algorithmRunStatuses.PAUSED]: PauseOutlined,
  [algorithmRunStatuses.READY]: PlayCircleOutlined,
  [algorithmRunStatuses.PENDING]: EllipsisOutlined,
}

interface SmartFunctionRunStatusIconProps {
  status: AlgorithmRunStatus
}

const SmartFunctionRunStatusIcon = ({
  status,
}: SmartFunctionRunStatusIconProps) => {
  if (!statusToComponentMap[status]) {
    return null
  }
  const IconComponent = statusToComponentMap[status]
  return <IconComponent />
}

export default SmartFunctionRunStatusIcon
